var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Installer-Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Integrations",
    transform: "translate(-501.000000, -551.000000)",
    fill: "#FF6F47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M509.000725,551 C513.419404,551 517.001451,554.581722 517.001451,559 C517.001451,563.418278 513.419404,567 509.000725,567 C504.582047,567 501,563.418278 501,559 C501,554.581722 504.582047,551 509.000725,551 Z M509.00875,554 C508.77875,554 508.592083,554.18625 508.592083,554.41625 L508.588333,558.583333 L504.416667,558.583333 C504.18625,558.583333 504,558.769583 504,559 C504,559.23 504.18625,559.416667 504.416667,559.416667 L508.5875,559.416667 L508.583333,563.582917 C508.582917,563.812917 508.769167,563.999583 508.999167,564 C509.229583,564 509.41625,563.81375 509.416667,563.58375 L509.416667,559.416667 L513.583333,559.416667 C513.813333,559.416667 514,559.23 514,559 C514,558.769583 513.813333,558.583333 513.583333,558.583333 L509.416667,558.583333 L509.416667,554.417083 C509.416667,554.186667 509.239167,554 509.00875,554 Z",
    id: "Combined-Shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/addIcon.87c36254dbc108a92723a3f4c79710cc.svg";